export const versionLog = {
  currentVersion: '1.0.14',
  versionChangeDate: '2025-11-26 15:00:00',
  showDays: 14,
};
